import Layout from '../../../../../common/components/layout/Layout';
import Header from '../../../../../common/components/layout/Header';
import PaymentLabels from '../../../../../common/components/modules/sports/PaymentLabels';
import LayoutInside from '../../../../../common/components/layout/LayoutInside';
import { Link, useLocation } from 'react-router-dom';
import MsjSuccess from '../../../../../common/components/sections/MsjSuccess';
import { attributesBySport } from '../../../../../common/data/attributes';
import { useCallback, useEffect, useState } from 'react';
import { getModel2 } from '../../../../../services/payment.service';
import Loading from '../../../../../common/loading/Loading';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

type GetClubAndFieldFromReservation = {
    transactionStatus: string;
    reservationId: string;
    reservationStart: string;
    reservationEnd: string;
    fieldId: string;
    fieldName: string;
    fieldDescription: string | null;
    clubId: string;
    clubName: string;
    clubAddress: string;
    clubPhoto: string | null;
    clubLogo: string;
    amount: number;
    challengeId: string;
};

const ClubsPayment = (): JSX.Element => {
    const attribute = attributesBySport('rent');
    const query = useQuery();
    const id = query.get('id');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState<GetClubAndFieldFromReservation | undefined>(undefined);

    // From the path futbol/desafiar/pago/fallo?id=OD-1731071232457 get futbol and desafiar as sport and type
    const pathname = useLocation().pathname.split('/');
    const sport = pathname[1];
    const type = pathname[2];

    const confirmPayment = useCallback(async () => {
        try {
            const transaction = await getModel2(`transactions/order/${id}`);

            console.log('AQUI 1', { transaction });

            if (transaction && transaction.data) {
                setData(transaction.data);
                setSuccess(true);
                setIsLoading(false);
                setError(false);
            } else {
                setError(true);
                setIsLoading(false);
                setSuccess(false);
            }
        } catch (error) {
            setSuccess(false);
            setError(true);
            setIsLoading(false);
        }

        setIsLoading(false);
    }, [id]);

    useEffect(() => {
        if (id && !isLoading && !success && !error) {
            setIsLoading(true);
            setSuccess(false);
            setError(false);
            confirmPayment();
        }

        if (!id) {
            setIsLoading(false);
            setError(true);
        }
    }, [id, isLoading, success, error, confirmPayment]);

    // First, handle loading state
    if (isLoading) {
        return <Loading />;
    }

    if (success && data) {
        return (
            <Layout navProps={{ title: 'Hubo un problema con el Pago | Supermatch', description: 'Pago Supermatch' }}>
                <>
                    <Header />
                    <LayoutInside attribute={attribute} title={'Error'} subTitle={''}>
                        <div className="flex flex-col justify-center items-center">
                            <div className="bg-white pt-5 w-full md:w-2/5 lg:w-2/5 sm:bg-opacity-50 sm:shadow-lg rounded-lg">
                                <div className="text-center p-6">
                                    <h3 className="text-xl font-bold text-red-600 mb-4">
                                        Hubo un problema con el pago
                                    </h3>
                                    <div className="flex justify-center my-10">
                                        <Link
                                            to={`/${sport}/${type}/pago/filter?challengeId=${data?.challengeId}`}
                                            className="text-sm text-white bg-sm-integrate  p-4 rounded-full m-5"
                                            href="/"
                                        >
                                            Volver a intentar
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </LayoutInside>
                </>
            </Layout>
        );
    }

    // Finally handle error state
    if (error) {
        return (
            <Layout navProps={{ title: 'Hubo un problema con el Pago | Supermatch', description: 'Pago Supermatch' }}>
                <>
                    <Header />
                    <LayoutInside attribute={attribute} title={'Error'} subTitle={''}>
                        <div className="flex flex-col justify-center items-center">
                            <div className="bg-white pt-5 w-full md:w-2/5 lg:w-2/5 sm:bg-opacity-50 sm:shadow-lg rounded-lg">
                                <div className="text-center p-6">
                                    <h3 className="text-xl font-bold text-red-600 mb-4">
                                        Hubo un problema con el pago
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </LayoutInside>
                </>
            </Layout>
        );
    }

    // Fallback loading state
    return <Loading />;
};

export default ClubsPayment;
